/* eslint-disable no-restricted-syntax */
import P from '@leverege/promise';
import debounce from 'p-debounce';
import TimelineDataset from "./TimelineDataset.js";
import { TIMELINE_MANAGER_ACTIONS } from "../hooks/Constants.js";
export default class TimelineManager {
  /**
   * @private
   * @type {Map<string,TimelineDataset>}
   */
  #datasets = new Map();
  constructor(options) {
    const {
      precision,
      dispatch
    } = options;
    this.precision = precision;
    this.dispatch = dispatch;
  }
  addDataset(key, dataset) {
    if (dataset instanceof TimelineDataset) {
      this.#datasets.set(key, dataset);
      this.dispatch({
        type: TIMELINE_MANAGER_ACTIONS.DATASET_ADDED,
        payload: {
          datasetId: key
        }
      });
    } else {
      console.warn('TimelineManager expected instanceof TimelineDataset', {
        dataset,
        key
      });
    }
  }
  getNearestData = debounce(async scrubTime => {
    /**
     * @type {Object<string,import('./TimelineDataset').TimelineDatum>}
     */
    const obj = Array.from(this.#datasets.entries()).reduce((prev, [key, dataset]) => {
      prev[key.replaceAll('/', '.')] = () => {
        this.dispatch({
          type: TIMELINE_MANAGER_ACTIONS.DATASET_LOADING_STARTED,
          payload: {
            datasetId: key
          }
        });
        return dataset.getNearestDatum(scrubTime, this.precision).then(res => {
          this.dispatch({
            type: TIMELINE_MANAGER_ACTIONS.DATASET_LOADED,
            payload: {
              datasetId: key,
              data: res
            }
          });
          return res;
        }).catch(err => {
          this.dispatch({
            type: TIMELINE_MANAGER_ACTIONS.ERROR_THROWN,
            payload: {
              datasetId: key,
              error: err
            }
          });
        });
      };
      return prev;
    }, {});
    return Object.entries(await P.all(obj, {
      handleReject: true
    })).reduce((prev, [key, value]) => {
      prev[key.replaceAll('.', '/')] = value;
      return prev;
    }, {});
  }, 250);
}